// ! There is lots of documentation about i18next and our approach to it in Notion
// https://www.notion.so/maul/Translations-for-web-3e1c19c3d3f14b85840af73dc5b3a55e

import i18next from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import Locize from "i18next-locize-backend"
import { Settings } from "luxon"
import { initReactI18next } from "react-i18next"
import { getClientEnv } from "./init/client-env-init"

const DETECTION_OPTIONS = {
  order: ["localStorage"],
  lookupLocalStorage: "i18nextLng",
  caches: ["localStorage"],
}

const domainDefaultLng = {
  localhost: "is",
  "restaurant.maul.is": "is",
  "kitchen.tiffin.dk": "da",
}[window.location.hostname]
const fallbackLng = domainDefaultLng ?? "en-GB"
console.log(`🌐 Setting i18next fallback language to '${fallbackLng}'`)

// https://www.i18next.com/overview/api#onlanguagechanged
// Sync the Amplify language with the i18next language
// Note that we must define the listeners before the configuration so the listeners
// are already set up when the configuration fires events.

i18next.on("languageChanged", (lng) => {
  console.log(
    `🌐 'languageChanged' event with payload '${lng}'.\n`,
    `  Syncing Amplify language.\n`,
    `  Syncing Luxon default locale.`,
  )

  Settings.defaultLocale = lng
})

i18next.on("initialized", (options) => {
  console.log("🌐 'initialized' event with payload", { options })
})
i18next.on("loaded", (loaded) => {
  console.log("🌐 'loaded' event with payload", { loaded })
})

let i18nextConf = {
  //resources,
  detection: DETECTION_OPTIONS,
  // lng: "eng", //this will overwrite the language detection if this is enabled.
  fallbackLng,
  defaultNS: "common",
  ns: ["common", "maul", "tiffin"],
  keySeparator: ".",
  debug: false && process.env.NODE_ENV === "development",
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
  backend: {
    projectId: getClientEnv().VITE_LOCIZE_PROJECT_ID,
    // We only need to set apiKey and referenceLng to use saveMissing feature of i18next, see
    // https://github.com/locize/i18next-locize-backend
    apiKey: getClientEnv().VITE_LOCIZE_API_KEY,
    referenceLng: "en",
    version: process.env.NODE_ENV === "development" ? "latest" : "production", // defaults to latest,
    cdnType: "pro",
  },
  react: {
    bindI18n: "languageChanged editorSaved",
  }, // This is from the locize github issue: https://github.com/locize/locize/issues/167
}

console.log("🌐 Setting up i18next with config")
console.log({ i18nextConf })

i18next
  .use(Locize) // https://github.com/locize/i18next-locize-backend
  .use(LanguageDetector) // https://github.com/i18next/i18next-browser-languageDetector
  .use(initReactI18next) // passes i18n down to react-i18next
  .init(i18nextConf)

export default i18next
